import React from 'react';
import PropTypes from 'prop-types';
import './Arrow.scss';

const Arrow = (props) => {
  const arrowClass = `${props.shouldRotate ? 'faq-question-arrow-down' : 'faq-question-arrow'}`;

  return <div className={arrowClass} role="presentation" />;
};

Arrow.propTypes = {
  shouldRotate: PropTypes.bool
};

export default Arrow;



/** WEBPACK FOOTER **
 ** ./src/components/Arrow/Arrow.js
 **/